// @ts-nocheck
/**
 * Generated by orval v7.1.0 🍺
 * Do not edit manually.
 * SUREnet producten-internal API
 * OpenAPI spec version: 1
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';
import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';
import type {
  CollectionResultOfProductenPakkettenPakketDto,
  ProductenPakkettenPakketDto,
  Result1OfProductenPakkettenPakketDto,
} from '../model';
import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingInzien</li></ul>
 * @summary Geeft een lijst van pakketten terug.
 */
export const pakkettenAll = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) =>
  customInstance<CollectionResultOfProductenPakkettenPakketDto>(
    { url: `/api/v1/pakketten`, method: 'GET', signal },
    options,
  );

export const getPakkettenAllQueryKey = () => ['api', 'v1', 'pakketten'] as const;

export const getPakkettenAllQueryOptions = <
  TData = Awaited<ReturnType<typeof pakkettenAll>>,
  TError = ErrorType<void>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof pakkettenAll>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getPakkettenAllQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof pakkettenAll>>> = ({ signal }) =>
    pakkettenAll(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof pakkettenAll>>,
    TError,
    TData
  >;
};

export type PakkettenAllQueryResult = NonNullable<Awaited<ReturnType<typeof pakkettenAll>>>;
export type PakkettenAllQueryError = ErrorType<void>;

/**
 * @summary Geeft een lijst van pakketten terug.
 */

export function usePakkettenAll<
  TData = Awaited<ReturnType<typeof pakkettenAll>>,
  TError = ErrorType<void>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof pakkettenAll>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPakkettenAllQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
 * @summary Voegt een nieuw pakket toe of wijzigt een bestaande.
 */
export const pakkettenPost = (
  productenPakkettenPakketDto: MaybeRef<ProductenPakkettenPakketDto>,
  options?: SecondParameter<typeof customInstance>,
) => {
  productenPakkettenPakketDto = unref(productenPakkettenPakketDto);

  return customInstance<void>(
    {
      url: `/api/v1/pakketten`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: productenPakkettenPakketDto,
    },
    options,
  );
};

export const getPakkettenPostMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof pakkettenPost>>,
    TError,
    { data: ProductenPakkettenPakketDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof pakkettenPost>>,
  TError,
  { data: ProductenPakkettenPakketDto },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof pakkettenPost>>,
    { data: ProductenPakkettenPakketDto }
  > = (props) => {
    const { data } = props ?? {};

    return pakkettenPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PakkettenPostMutationResult = NonNullable<Awaited<ReturnType<typeof pakkettenPost>>>;
export type PakkettenPostMutationBody = ProductenPakkettenPakketDto;
export type PakkettenPostMutationError = ErrorType<void>;

/**
 * @summary Voegt een nieuw pakket toe of wijzigt een bestaande.
 */
export const usePakkettenPost = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof pakkettenPost>>,
    TError,
    { data: ProductenPakkettenPakketDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationReturnType<
  Awaited<ReturnType<typeof pakkettenPost>>,
  TError,
  { data: ProductenPakkettenPakketDto },
  TContext
> => {
  const mutationOptions = getPakkettenPostMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingInzien</li></ul>
 * @summary Haalt een pakket op, op basis van pakketId
 */
export const pakkettenGetByPakketId = (
  pakketId: MaybeRef<string | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  pakketId = unref(pakketId);

  return customInstance<Result1OfProductenPakkettenPakketDto>(
    { url: `/api/v1/pakketten/${pakketId}`, method: 'GET', signal },
    options,
  );
};

export const getPakkettenGetByPakketIdQueryKey = (pakketId: MaybeRef<string | undefined | null>) =>
  ['api', 'v1', 'pakketten', pakketId] as const;

export const getPakkettenGetByPakketIdQueryOptions = <
  TData = Awaited<ReturnType<typeof pakkettenGetByPakketId>>,
  TError = ErrorType<void>,
>(
  pakketId: MaybeRef<string | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof pakkettenGetByPakketId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getPakkettenGetByPakketIdQueryKey(pakketId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof pakkettenGetByPakketId>>> = ({ signal }) =>
    pakkettenGetByPakketId(pakketId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(pakketId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof pakkettenGetByPakketId>>, TError, TData>;
};

export type PakkettenGetByPakketIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof pakkettenGetByPakketId>>
>;
export type PakkettenGetByPakketIdQueryError = ErrorType<void>;

/**
 * @summary Haalt een pakket op, op basis van pakketId
 */

export function usePakkettenGetByPakketId<
  TData = Awaited<ReturnType<typeof pakkettenGetByPakketId>>,
  TError = ErrorType<void>,
>(
  pakketId: MaybeRef<string | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof pakkettenGetByPakketId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPakkettenGetByPakketIdQueryOptions(pakketId, options);

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}
